import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ScheduledPaymentModel } from '../../models';
import { FormInputChangedModel } from '../../../shared/models';

@Component({
  selector: 'rnpl-scheduled-payment-properties-partner',
  templateUrl: './scheduled-payment-properties-partner.component.html',
})
export class ScheduledPaymentPropertiesPartnerComponent {

  @Input() readonly scheduledPayment: ScheduledPaymentModel;
  @Input() readonly form: FormGroup;
  @Input() readonly isView: boolean;

  @Output() fieldChanged: EventEmitter<FormInputChangedModel> = new EventEmitter<FormInputChangedModel>();

  public updateField(fieldValue: any, fieldName: string): void {
    this.fieldChanged.emit({fieldName, fieldValue});
  }

  public customerChanged(e): void {
    this.fieldChanged.emit({fieldName: 'properties.partnerProfile', fieldValue: e});
  }

  get partnerId(): FormControl { return this.form.get('properties').get('partnerProfile').get('id') as FormControl; }
  get partnerType(): FormControl { return this.form.get('properties').get('partnerProfile').get('type') as FormControl; }
  get branchOfficeId(): FormControl { return this.form.get('properties').get('branchOffice').get('id') as FormControl; }

}
